/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReserveTripMapBreaks,
    ReserveTripMapBreaksFromJSON,
    ReserveTripMapBreaksFromJSONTyped,
    ReserveTripMapBreaksToJSON,
    ReserveTripMapDriverCancels,
    ReserveTripMapDriverCancelsFromJSON,
    ReserveTripMapDriverCancelsFromJSONTyped,
    ReserveTripMapDriverCancelsToJSON,
    ReserveTripMapRoutes,
    ReserveTripMapRoutesFromJSON,
    ReserveTripMapRoutesFromJSONTyped,
    ReserveTripMapRoutesToJSON,
    ReserveTripMapTerminalStatus,
    ReserveTripMapTerminalStatusFromJSON,
    ReserveTripMapTerminalStatusFromJSONTyped,
    ReserveTripMapTerminalStatusToJSON,
} from './';

/**
 * 地図上に描画する乗車１回分のデータ
 * @export
 * @interface ReserveTripMap
 */
export interface ReserveTripMap {
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMap
     */
    shiftStartDt?: string;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof ReserveTripMap
     */
    driverCode?: string;
    /**
     * 乗務員名
     * @type {string}
     * @memberof ReserveTripMap
     */
    driverName?: string;
    /**
     * ログイン(開局) 単位で発行されるID
     * @type {string}
     * @memberof ReserveTripMap
     */
    loginSessionId?: string;
    /**
     * 空車での trip_session_id
     * @type {string}
     * @memberof ReserveTripMap
     */
    unladenTripSessionId?: string;
    /**
     * 空車開始時刻(UTC, フォーマット '2023-05-02T04:13:18Z')
     * @type {string}
     * @memberof ReserveTripMap
     */
    unladenStartTs?: string;
    /**
     * 空車開始位置(wktフォーマット)
     * @type {string}
     * @memberof ReserveTripMap
     */
    unladenStartLoc?: string;
    /**
     * 空車終了時刻(UTC, フォーマット '2023-05-02T04:13:18Z')
     * @type {string}
     * @memberof ReserveTripMap
     */
    unladenEndTs?: string;
    /**
     * 空車終了位置(wktフォーマット)
     * @type {string}
     * @memberof ReserveTripMap
     */
    unladenEndLoc?: string;
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMap
     */
    unladenShape?: string;
    /**
     * 乗車種別 (cruising/stand/go/tel/cancel_tel/homing/error)
     * @type {string}
     * @memberof ReserveTripMap
     */
    boardingType?: string;
    /**
     * hermes->sumidenと変換された実際に表示された経路
     * @type {Array<ReserveTripMapRoutes>}
     * @memberof ReserveTripMap
     */
    routes?: Array<ReserveTripMapRoutes>;
    /**
     * 5分ごとの端末の状態を記録したデータ
     * @type {Array<ReserveTripMapTerminalStatus>}
     * @memberof ReserveTripMap
     */
    terminalStatus?: Array<ReserveTripMapTerminalStatus>;
    /**
     * 
     * @type {Array<ReserveTripMapBreaks>}
     * @memberof ReserveTripMap
     */
    breaks?: Array<ReserveTripMapBreaks>;
    /**
     * 
     * @type {Array<ReserveTripMapDriverCancels>}
     * @memberof ReserveTripMap
     */
    driverCancels?: Array<ReserveTripMapDriverCancels>;
}

export function ReserveTripMapFromJSON(json: any): ReserveTripMap {
    return ReserveTripMapFromJSONTyped(json, false);
}

export function ReserveTripMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripMap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftStartDt': !exists(json, 'shift_start_dt') ? undefined : json['shift_start_dt'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'loginSessionId': !exists(json, 'login_session_id') ? undefined : json['login_session_id'],
        'unladenTripSessionId': !exists(json, 'unladen_trip_session_id') ? undefined : json['unladen_trip_session_id'],
        'unladenStartTs': !exists(json, 'unladen_start_ts') ? undefined : json['unladen_start_ts'],
        'unladenStartLoc': !exists(json, 'unladen_start_loc') ? undefined : json['unladen_start_loc'],
        'unladenEndTs': !exists(json, 'unladen_end_ts') ? undefined : json['unladen_end_ts'],
        'unladenEndLoc': !exists(json, 'unladen_end_loc') ? undefined : json['unladen_end_loc'],
        'unladenShape': !exists(json, 'unladen_shape') ? undefined : json['unladen_shape'],
        'boardingType': !exists(json, 'boarding_type') ? undefined : json['boarding_type'],
        'routes': !exists(json, 'routes') ? undefined : ((json['routes'] as Array<any>).map(ReserveTripMapRoutesFromJSON)),
        'terminalStatus': !exists(json, 'terminal_status') ? undefined : ((json['terminal_status'] as Array<any>).map(ReserveTripMapTerminalStatusFromJSON)),
        'breaks': !exists(json, 'breaks') ? undefined : ((json['breaks'] as Array<any>).map(ReserveTripMapBreaksFromJSON)),
        'driverCancels': !exists(json, 'driver_cancels') ? undefined : ((json['driver_cancels'] as Array<any>).map(ReserveTripMapDriverCancelsFromJSON)),
    };
}

export function ReserveTripMapToJSON(value?: ReserveTripMap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_start_dt': value.shiftStartDt,
        'driver_code': value.driverCode,
        'driver_name': value.driverName,
        'login_session_id': value.loginSessionId,
        'unladen_trip_session_id': value.unladenTripSessionId,
        'unladen_start_ts': value.unladenStartTs,
        'unladen_start_loc': value.unladenStartLoc,
        'unladen_end_ts': value.unladenEndTs,
        'unladen_end_loc': value.unladenEndLoc,
        'unladen_shape': value.unladenShape,
        'boarding_type': value.boardingType,
        'routes': value.routes === undefined ? undefined : ((value.routes as Array<any>).map(ReserveTripMapRoutesToJSON)),
        'terminal_status': value.terminalStatus === undefined ? undefined : ((value.terminalStatus as Array<any>).map(ReserveTripMapTerminalStatusToJSON)),
        'breaks': value.breaks === undefined ? undefined : ((value.breaks as Array<any>).map(ReserveTripMapBreaksToJSON)),
        'driver_cancels': value.driverCancels === undefined ? undefined : ((value.driverCancels as Array<any>).map(ReserveTripMapDriverCancelsToJSON)),
    };
}


